import React, { useEffect, useState, useContext } from 'react'
import { useLocation } from 'react-router';
import styles from './OrderDetails.module.sass';
import OrderDetailsView from './OrderDetailsView';
import PopularProducts from './PopularProducts'
import cn from "classnames";
import Icon from '../../components/Icon';
import Dropdown from '../../components/Dropdown';
import { getOrderById, getOrderItemsById, getProductById, updateOrderById } from '../../Firebase/firebaseDatabase';
import LoadingIndicator from '../../LoadingScreen/LoadingIndicator';
import { GlobalState } from '../../App'
import LoadingDialog from '../../LoadingScreen/LoadingDialog';
import { ORDER_STATUS, ORDER_STATUS_1 } from '../../utils/constants';
// import Control from './Control';
import ConfirmationPopup from './ConfirmationPopup/ConfirmationPopup';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { toIsoString } from '../../utils/extensions';
import axios from 'axios';
import { getSellerById } from '../../Firebase/firebaseDatabase';
import { EmailTemplate } from './EmailTemplate';
import { Timestamp, collection, getDocs, where } from 'firebase/firestore';
import { db } from '../../Firebase/firebaseConfig';
import { EmailOrderItem } from './EmailOrderItem';
import AddCreditMemoPopup from './AddCreditMemoPopup/AddCreditMemoPopup';

const OrderDetails = () => {

    const theme = useTheme();
    const matches1023 = useMediaQuery(theme.breakpoints.down(1024));

    const location = useLocation()
    const [orderId, setOrderId] = useState()

    const [loading, setLoading] = useState(true)
    const [orderDetails, setOrderDetails] = useState()

    const optionsStatus = ["Select status", "In Progress", "Extended", "Complete", "Cancelled"]
    const [orderStatus, setOrderStatus] = useState(optionsStatus[0])

    const [sellerEmail, setSellerEmail] = useState()


    const { setIsActionComplete, isActionComplete, isClicked, setIsClicked,
        isConfirmUpdateStatus, setIsConfirmUpdateStatus, showModalView, setShowModalView } = useContext(GlobalState)

    const getOrderDetails = async () => {

        try {
            await getOrderById(orderId).then((details) => {

                details[0].data.dateCreated = toIsoString(new Date(
                    details[0].data.dateCreated?.seconds * 1000 + details[0]?.data?.dateCreated?.nanoseconds / 1000000
                ))

                if (details[0]?.data?.dateExtended !== '' && details[0]?.data?.dateExtended !== "NAN") {
                    details[0].data.dateExtended = toIsoString(new Date(
                        details[0].data?.dateExtended?.seconds * 1000 + details[0]?.data?.dateExtended?.nanoseconds / 1000000
                    ))
                }

                if (details[0]?.data.status === "IN PROGRESS") {
                    const shippingTimeFrameDays = details[0].data.shippingTimeframe.split('-')[1].split(" ")[0]
                    const dateCreate = new Date(details[0]?.data?.dateCreated)
                    const checkDate = new Date(dateCreate.setDate(dateCreate.getDate() + parseInt(shippingTimeFrameDays)))
                    if (new Date() >= checkDate) {
                        details[0].data.status = "NEED ATTENTION"
                    }
                }
                if (details[0]?.data.status === "EXTENDED") {
                    const extendedDate = new Date(details[0].data?.dateExtended)
                    if (details[0]?.data?.shippingTimeframe !== '') {
                        if (new Date() >= extendedDate) {
                            details[0].data.status = "NEED ATTENTION"
                        }
                    }
                     else {
                        if (new Date() >= extendedDate) {
                            details[0].data.status = "NEED ATTENTION"
                        }
                    }

                }
                setTimeout(() => {
                    setOrderDetails(details)
                    setLoading(false)
                }, 1000);


            })

        } catch (error) {
            setLoading(false)
        }
    }

    useEffect(() => {
        setIsActionComplete(false);
    }, [])

    useEffect(() => {
    }, [isActionComplete, isClicked, isConfirmUpdateStatus])

    useEffect(() => {
        setLoading(true)
        setOrderId(location.pathname.split("/")[2])
        getOrderDetails()
    }, [orderId])

    useEffect(() => {

    }, [orderDetails])

    const getSellerDetails = (sellerid) => {
        return new Promise(async (resolve, reject) => {
            await getSellerById(sellerid).then(sellerData => {
                resolve(sellerData)
            })
        })
    }


    const orderItemsList = []
    const [orderItemsListFinal, setOrderItemsListFinal] = useState()
    const createEmailItemsTable = (details) => {
        details.forEach((item, index, array) => {
            orderItemsList.push(EmailOrderItem(item.data.product.variation.image, item.data.product.title, item.data.product.sellerName, item.data.product.variation.sku, item.data.quantity, item.data.product.price))
            if (array.length - 1 === index) {
                setOrderItemsListFinal(orderItemsList.filter((x, i, a) => a.indexOf(x) === i).join(""))
            }
        })

    }

    const getOrderItemsList = async (sellerName) => {
        try {
            const details = await getOrderItemsById(orderId);
            await details.forEach(async (element, index, array) => {
                let object = {
                    variation: {
                        sku: "",
                        image: "",
                    },
                    title: "",
                    sellerName: sellerName,
                    price: ''
                };
                await getProductById(element?.data?.productId)
                    .then(async (productDetails) => {
                        object.title = productDetails[0]?.data?.titleEn;
                        object.price = productDetails[0]?.data?.price;
                        await getDocs(
                            collection(db, "product", productDetails[0]?.id, "variation"),
                            where("id", "==", element?.data?.variationId)
                        )
                            .then(async (doc) => {
                                const variationDetails = doc.docs.map((doc) => ({
                                    data: doc.data(),
                                    id: doc.id,
                                }));
                                object.variation.sku = await variationDetails[0]?.data?.sku;
                                object.variation.image = await variationDetails[0]?.data
                                    ?.images[0];

                                details[index]["data"]["product"] = object;

                                if (array.length - 1 === index) {
                                    createEmailItemsTable(details)
                                }

                            })
                            .catch((e) => {
                                setLoading(false);
                            });
                    })
                    .catch((e) => {
                        console.log("ORDER ERROR", e);
                        setLoading(false);
                    });

            });
        } catch (e) {
            console.log("ORDER ERROR", e);
            setLoading(false);
        }
    };

    useEffect(() => {

        if (orderDetails !== undefined) {

            if (orderDetails[0]?.data?.status !== '') {
                console.log(orderDetails[0]?.data?.status)
                setOrderStatus(orderDetails[0]?.data?.status)
                getSellerDetails(orderDetails[0]?.data?.sellerId).then(sellerData => {
                    if (sellerData !== undefined && sellerData.length !== 0) {
                        setSellerEmail(sellerData[0].data.email)
                        getOrderItemsList(sellerData[0].data.nameEn)
                    }
                })


            }
        }
    }, [orderDetails])


    const handleChangeStatus = () => {
        setIsClicked(true)
        setTimeout(() => {
            const updateStatus = document.getElementById(ORDER_STATUS_1).value
            if (orderDetails !== undefined) {
                if (updateStatus?.toUpperCase() !== orderDetails[0]?.data?.status) {

                    orderDetails[0].data.status = updateStatus?.toUpperCase();
                    const updatedOrderDetails = orderDetails[0].data
                    updatedOrderDetails.dateCreated = Timestamp.fromDate(new Date(orderDetails[0].data.dateCreated.split("T")[0]))
                    var date = new Date();
                    console.log(updatedOrderDetails?.status)
                    if(updatedOrderDetails?.status === "EXTENDED"){
                        updatedOrderDetails.dateExtended = Timestamp.fromDate(new Date(new Date(date).setHours(24 * updatedOrderDetails?.shippingTimeframe.split('-')[1].split(" ")[0])))
                    }
                    updateOrderById(orderId, updatedOrderDetails, setIsActionComplete, setIsClicked).then((res) => {
                        if (res === true) {
                            setIsConfirmUpdateStatus(true)
                        }
                    })
                } else {
                    setIsClicked(false)
                }
            } else {
                setIsClicked(false)
            }
        }, 1000)

    }

    const sendEmail = (otp) => {
        var data = JSON.stringify({
            "sender": {
                "name": "SmSm",
                "email": "no-reply@smsm.sa"
            },
            "to": [
                {
                    "email": sellerEmail
                }
            ],
            "subject": "Order notification",
            "htmlContent": EmailTemplate(orderDetails[0].id, orderDetails[0].data.dateCreated, orderDetails[0].data.customerAddress,
                orderDetails[0].data.customerName, orderDetails[0].data.contactNumber, orderDetails[0].data.subtotal,
                orderDetails[0].data.shippingCost, orderDetails[0].data.vatAmount, orderDetails[0].data.total, orderItemsListFinal)
        });

        var config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://api.sendinblue.com/v3/smtp/email',
            headers: {
                'api-key': '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',
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    return (
        <div className={styles.section}>

            {
                isConfirmUpdateStatus ? <ConfirmationPopup /> : <></>
            }

            {
                showModalView ?
                    <AddCreditMemoPopup data={orderDetails} memoDescription={orderDetails[0]?.data?.creditMemo ? orderDetails[0]?.data?.creditMemo : ""} />
                    : <></>
            }

            {loading ?
                <LoadingIndicator />
                :
                <div className={styles.row}>

                    {
                        !matches1023 ?
                            <>
                                <div className={styles.col}>
                                    <OrderDetailsView orderDetails={orderDetails} />
                                </div>
                                <div className={styles.col}>
                                    <div className={styles.orderActionButtonsContainer}>
                                        <button
                                            className={cn("button", styles.button)}
                                            onClick={() => sendEmail()}
                                        >
                                            <Icon name="mail" size={22} />
                                            <span>Send E-Mail</span>
                                        </button>

                                        <button
                                            onClick={() => {
                                                setShowModalView(true)
                                            }}
                                            className={cn("button", styles.button, styles.creditMemoBtn)} >
                                            <Icon fill="black" name="multiselect" size={22} />
                                            <span>Credit Memo</span>
                                        </button>
                                        {
                                            orderDetails && orderDetails[0]?.data?.creditMemo ? <p>{orderDetails[0]?.data?.creditMemo}</p> : <></>
                                        }

                                    </div>


                                    <div className={styles.statusDropdownContainer}>
                                        {
                                            isClicked ?
                                                !isActionComplete ? <LoadingDialog /> : <></>
                                                : <></>
                                        }
                                        <Dropdown
                                            className={styles.smallDropdownField}
                                            classDropdownLabel={styles.smallDropdownlabel}
                                            label="Status"
                                            value={orderStatus}
                                            setValue={setOrderStatus}
                                            options={optionsStatus}
                                            isFrom={ORDER_STATUS}
                                            onClick={() => handleChangeStatus()}
                                        />
                                    </div>

                                    <PopularProducts orderId={orderId} />
                                </div>
                            </> :
                            <>

                                <div className={styles.col}>
                                    <div className={styles.orderActionButtonsContainer}>
                                        <button
                                            className={cn("button", styles.button)} >
                                            <Icon name="mail" size={22} />
                                            <span>Send E-Mail</span>
                                        </button>

                                        <button
                                            onClick={() => {
                                                setShowModalView(true)
                                            }}
                                            className={cn("button", styles.button, styles.creditMemoBtn)} >
                                            <Icon fill="black" name="multiselect" size={22} />
                                            <span>Credit Memo</span>
                                        </button>
                                        {
                                            orderDetails && orderDetails[0]?.data?.creditMemo ? <p>{orderDetails[0]?.data?.creditMemo}</p> : <></>
                                        }

                                    </div>

                                    <div className={styles.statusDropdownContainer}>
                                        {
                                            isClicked ?
                                                !isActionComplete ? <LoadingDialog /> : <></>
                                                : <></>
                                        }
                                        {/* <Control /> */}
                                        <Dropdown
                                            className={styles.smallDropdownField}
                                            classDropdownLabel={styles.smallDropdownlabel}
                                            label="Status"
                                            value={orderStatus}
                                            setValue={setOrderStatus}
                                            options={optionsStatus}
                                            isFrom={ORDER_STATUS}
                                            onClick={() => handleChangeStatus()}
                                        />
                                    </div>

                                    <PopularProducts orderId={orderId} />
                                </div>
                                <div className={styles.col}>
                                    <OrderDetailsView orderDetails={orderDetails} />
                                </div>
                            </>
                    }

                </div>

            }

        </div>
    )
}

export default OrderDetails